import React from 'react'
import { useNavigate, useParams, useLocation } from 'react-router-dom'
import { useQuery } from 'react-query';
import { getLedgerByID } from '../../../../api/apiServices';

const ViewLedger = () => {

    const params = useParams();
    const id = parseInt(params.id)

    const navigate = useNavigate();
    const location = useLocation();
    const from = location.state?.from?.pathname || "/ledger_account";

    const {
        isLoading,
        isError,
        error,
        data: memberLedger
    } = useQuery(['memberLedger', id], () => getLedgerByID(id));

   
    const handleCancel = () => {
        navigate(-1);
    }

    let totalPayment = 0;
    let ledgerData = [];
    let paymentData = [];

    const FullName = memberLedger?.member?.first_name + " " + memberLedger?.member?.middle_name + " " + memberLedger?.member?.last_name


    // Member Ledger Account
    {
        memberLedger?.ledger?.map((ledg, index) => {
            let ledgData = {
                id: index,
                year: ledg.year,
                pf_number: ledg.pf_number,
                transaction_date: ledg.transaction_date,
                opening_balance: ledg.opening_balance,
                expected_total_amount: ledg.expected_total_amount,
                total_amount_paid: ledg.total_amount_paid,
                closing_balance: ledg.closing_balance
            }
            ledgerData.push(ledgData);
        })
    }

    // Member Payments
    {
        memberLedger?.payment?.map((paymtData, index) => {
            totalPayment += paymtData.payment_amount
            let payData = {
                id: index,
                year: paymtData.year,
                payment_date: paymtData.payment_date,
                payment_type: paymtData.payment_type,
                description: paymtData.description.toUpperCase(),
                receipt_number: paymtData.receipt_number,
                payment_amount: paymtData.payment_amount.toLocaleString(undefined, { minimumFractionDigits: 2 }),
            }
            paymentData.push(payData);
        })
    }


    const memberInfo = (
        <>
            <div className="table-responsive lg">
                <table className='table table-borderless'>
                    <tbody>
                        <tr>
                            <td>FULL NAME</td>
                            <td><b>{memberLedger?.member?.first_name} {memberLedger?.member?.middle_name} {memberLedger?.member?.last_name}</b></td>
                            <td>MOBILE</td>
                            <td><b>{memberLedger?.member?.mobile_number}</b></td>
                        </tr>
                        <tr>
                            <td>PF NUMBER</td>
                            <td><b>{memberLedger?.member?.pf_number}</b></td>
                            <td>EMAIL ADDRESS</td>
                            <td><b>{memberLedger?.member?.email}</b></td>
                        </tr>
                        <tr>
                            <td>VOTER ID</td>
                            <td><b>{memberLedger?.member?.voter_id_number}</b></td>
                            <td>REGION</td>
                            <td><b>{memberLedger?.member?.region}</b></td>
                        </tr>
                        <tr>
                            <td>DATE JOINED</td>
                            <td><b>{memberLedger?.member?.date_joined}</b></td>
                            <td>PROFESSION</td>
                            <td><b>{memberLedger?.member?.profession}</b></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </>
    )
    let content
    if (isLoading) {
        content = <p>Loading Members Data...</p>
    }
    else if (isError) {
        content = <p>{error.message}</p>
    } else {
        content =
            (
                <>
                    <legend>Payment Transactions</legend>
                    <div className="table-responsive lg">
                        <table className='table table-borderless table-striped'>
                            <thead>
                                <tr>
                                    <th style={{ textAlign: "center" }}>Year</th>
                                    <th style={{ textAlign: "center" }}>Payment Date</th>
                                    <th style={{}}>Receipt Number</th>
                                    <th style={{}}>Payment Type</th>
                                    <th style={{ whiteSpace: "nowrap" }}>Description</th>
                                    <th style={{ textAlign: "right" }}>Amount (GHS)</th>
                                </tr>
                            </thead>
                            <tbody>
                                {paymentData.map((payment, index) => (
                                    <tr key={payment.id}>
                                        <td style={{ textAlign: "center" }}>{payment.year}</td>
                                        <td style={{ textAlign: "center" }}>{payment.payment_date}</td>
                                        <td style={{ textAlign: "left" }}>{payment.receipt_number}</td>
                                        <td style={{ textTransform: "uppercase" }}>{payment.payment_type}</td>
                                        <td style={{ whiteSpace: "nowrap" }}>{payment.description}</td>
                                        <td style={{ textAlign: "right" }}>{payment.payment_amount.toLocaleString(undefined, { minimumFractionDigits: 2 })}</td>
                                    </tr>
                                ))}
                                <tr>
                                    <td colSpan="5" className="border-bottom" style={{ width: "55%", textAlign: "left", fontSize: "16px", fontWeight: "700", color: "darkred" }}>
                                        TOTAL PAYMENT
                                    </td>
                                    {totalPayment < 0 ? (
                                        <td className="border-bottom" style={{ width: "40%", textAlign: "right", fontSize: "16px", fontWeight: "700", color: "darkred" }}>
                                            ({(totalPayment * -1).toLocaleString(undefined, { minimumFractionDigits: 2 })}) </td>
                                    ) : (
                                        <td className="border-bottom" style={{ width: "40%", textAlign: "right", fontSize: "16px", fontWeight: "700", color: "darkred" }}>
                                            {totalPayment.toLocaleString(undefined, { minimumFractionDigits: 2 })} </td>
                                    )}
                                </tr>
                                <tr>
                                    <td colSpan="7" style={{ width: "95%", borderBottom: "5px" }}></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <br />

                    <legend>Ledger Account</legend>
                    <div className="table-responsive lg">
                        <table className='table table-borderless table-striped'>
                            <thead>
                                <tr>
                                    <th style={{ textAlign: "center" }}>Year</th>
                                    <th style={{ textAlign: "left" }}>Ledger Date</th>
                                    <th style={{ textAlign: "right" }}>Opening Balance</th>
                                    <th style={{ textAlign: "right" }}>Expected Payment</th>
                                    <th style={{ textAlign: "right" }}>Amount Paid</th>
                                    <th style={{ textAlign: "right" }}>Closing Balance </th>
                                </tr>
                            </thead>
                            <tbody>
                                {ledgerData?.map((ledger, index) => (
                                    <>
                                        <tr key={ledger.id}>
                                            <td style={{ textAlign: "center" }}>{ledger?.year}</td>
                                            <td style={{ textAlign: "left" }}>{ledger?.transaction_date}</td>
                                            {ledger?.opening_balance < 0 ? (
                                                <td style={{ textAlign: "right" }}>({(ledger?.opening_balance * -1).toLocaleString(undefined, { minimumFractionDigits: 2 })}) </td>
                                            ) : (
                                                <td style={{ textAlign: "right" }}>{ledger?.opening_balance.toLocaleString(undefined, { minimumFractionDigits: 2 })} </td>
                                            )}
                                            {ledger?.expected_total_amount < 0 ? (
                                                <td style={{ textAlign: "right" }}>({(ledger?.expected_total_amount * -1).toLocaleString(undefined, { minimumFractionDigits: 2 })}) </td>
                                            ) : (
                                                <td style={{ textAlign: "right" }}>{ledger?.expected_total_amount.toLocaleString(undefined, { minimumFractionDigits: 2 })} </td>
                                            )}
                                            <td style={{ textAlign: "right" }}>{ledger?.total_amount_paid.toLocaleString(undefined, { minimumFractionDigits: 2 })} </td>
                                            {ledger?.closing_balance < 0 ? (
                                                <td style={{ textAlign: "right" }}>({(ledger?.closing_balance * -1).toLocaleString(undefined, { minimumFractionDigits: 2 })}) </td>
                                            ) : (
                                                <td style={{ textAlign: "right" }}>{ledger?.closing_balance.toLocaleString(undefined, { minimumFractionDigits: 2 })} </td>
                                            )}
                                        </tr>
                                    </>
                                ))}
                            </tbody>
                            <tbody>
                                <tr>
                                    <td colSpan="6"></td>
                                </tr>
                                <tr>
                                    <td colSpan="7" style={{ width: "95%", borderBottom: "5px" }}></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </>
            )
    }
    return (
        <>
            <section className="content-header">
                <h1>Member Ledger Account - {FullName}</h1>
            </section>
            <section className="content">
                <div className="box">
                    <div className="box-body">
                        <div className="panel panel-default panel-br-4">
                            <div className="panel-heading">
                                <div className="row">
                                    <div className="col-sm-12">
                                        <h4 className="panel-title">
                                            {memberInfo}
                                        </h4>
                                    </div>
                                </div>
                            </div>
                            <div className="panel-body">
                                {content}
                            </div>
                            <div className="panel-footer">
                                <div className='form-group row'>
                                    <div className="col-sm-2">
                                        <button
                                            type="submit"
                                            className="btn btn-danger"
                                            onClick={handleCancel}
                                        > <i className="fa fa-times"></i> Cancel</button>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default ViewLedger